module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [(_vm.loader === 'rolling') ? _c('svg', {
    staticClass: "svg-loader loader-rolling",
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 100 100",
      "preserveAspectRatio": "xMidYMid",
      "width": "200px",
      "height": "200px"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "fill": "none",
      "stroke": "#FFF",
      "stroke-width": "5",
      "r": "35",
      "stroke-dasharray": "150 50",
      "transform": "rotate(114 50 50)"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "type": "rotate",
      "calcMode": "linear",
      "values": "0 50 50;360 50 50",
      "keyTimes": "0;1",
      "dur": "1s",
      "begin": "0s",
      "repeatCount": "indefinite"
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23fecab1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loaders.vue
// module id = 211
// module chunks = 1